import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
import CommentProfile from './commentProfile';
import CommentDetails from './commentDetails';
import { db } from '../../../../../Config/Firebase/config';
import { getCurrentDate } from '../../../../../Utility/utils';
import ReplyForm from './ReplyForm';
import ViewReplies from './viewReplies';

const CommentList = ({user, blogId, blog, setBlog}) => {
    const [commentError, setCommentError] = useState('');
    const [reply, setReply] = useState([]);
    const [replyMsg, setReplyMsg] = useState('');
    const [activeReplyIndex, setActiveReplyIndex] = useState(null);
    const [viewReplies, setViewReplies] = useState(false);
    const [commentIndex, setCommentIndex] = useState(null);

    const handleReply = (index) => {
        setReply([...reply, index]);
        setActiveReplyIndex(index);
    }

    const handleCancelReply = () => {
        setReply([]);
        setActiveReplyIndex(null);
        setReplyMsg('');
        setCommentError('');
    }

    const handleReplyMsgChange = (e) => {
        e.preventDefault();
        setReplyMsg(e.target.value);
    }

    const handleViewAllReplies = (e, index) => {
        e.preventDefault();
        if(commentIndex !== null && commentIndex !== index){
            setCommentIndex(index);
            setViewReplies(true);
        }else{
            setCommentIndex(index);
            setViewReplies(!viewReplies);
        }
    }

    const handlePostReply = async (commentIndex, e) => {
        e.preventDefault();
        setCommentError('');
        if (replyMsg.trim() === '') {
            setCommentError('Reply message is required');
            return;
        }
        if (!navigator.onLine) {
            return toast.error("no_internet_connection");
        }
        const blogRef = doc(db, "blogdata", blogId);
        try {
            if (!user) {
                return toast.info('Sign in to post a reply');
            } else {
                const newReply = {
                    userId: user?.uid,
                    username: user?.displayName,
                    replyMsg: replyMsg,
                    profile: user?.photoURL,
                    date: getCurrentDate(),
                };

                const updatedComments = [...blog.comments];
                updatedComments[commentIndex].reply.push(newReply);

                const updatedBlogData = {
                    ...blog,
                    comments: updatedComments,
                };
                await updateDoc(blogRef, updatedBlogData);
                setBlog((prevBlog) => ({ ...prevBlog, ...updatedBlogData }));

                toast.success("Reply Posted Successfully");
                setReply(reply.filter((item) => item !== commentIndex));
                setActiveReplyIndex(null);
                setReplyMsg('');
            }
        } catch (error) {
            console.log(error);
            toast.error("Could not Post Reply");
        }
    }

    return (
        <div className="comment-list padd-15">
            {
                blog.comments?.map((data, index) => (
                    <div className="user-comment" key={blogId + index}>
                        <CommentProfile
                            profile = {data.profile}
                        />
                        <div className="comment-detail">
                            <CommentDetails
                                username ={data.username}
                                date = {data.date}
                                comment = {data.comment}
                            />
                            {data.reply.length !== 0 ? (
                                <div className="reply-list">
                                    <h4 
                                        className='view-reply-btn'
                                        onClick={(e) => handleViewAllReplies(e, index)}
                                    >
                                        {viewReplies && index === commentIndex ?
                                        'Hide All Replies' :
                                        'View All Replies'}
                                    </h4>
                                </div>
                            ) : <div></div>}
                            {
                                viewReplies && index === commentIndex ?
                                <ViewReplies 
                                    reply={data.reply}
                                    blogId={blogId}
                                /> : <div></div>
                            }
                            {reply.includes(index) ? (
                                <ReplyForm 
                                    commentError = {commentError}
                                    replyMsg = {replyMsg}
                                    handleReplyMsgChange = {handleReplyMsgChange}
                                    handlePostReply = {handlePostReply}
                                    handleCancelReply = {handleCancelReply}
                                    index = {index}
                                />
                            ) : (
                                <div className="reply-btn-container">
                                    {activeReplyIndex === null && (
                                        <button className="btn reply-btn" onClick={() => handleReply(index)}>Reply</button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))
            }
        </div>
    );
}

export default CommentList;
